<template>
  <el-container class="app-shell" :class="{ 'group-mobile-shell': $route.path === '/facebook-group-monitor', 'group-nav-open': groupNavOpen }">
    <button v-if="groupNavOpen && $route.path === '/facebook-group-monitor'" class="group-nav-backdrop" aria-label="关闭导航" @click="groupNavOpen = false" />
    <el-aside width="220px" class="sidebar">
      <div class="brand">
        <span class="brand-mark"><img :src="auroraMark" alt="擎天柱系统"></span>
        <span class="brand-copy"><strong>擎天柱系统</strong><small>OPS COMMAND</small></span>
      </div>
      <el-menu router :default-active="activeMenu" background-color="#fff" text-color="#58677f" active-text-color="#4b8bf4" @select="groupNavOpen = false">
        <el-submenu v-if="groupAccess(['articles', 'crawl', 'sites'])" index="/article-group">
          <template slot="title"><i class="el-icon-document"></i><span>文章</span></template>
          <el-menu-item v-if="canAccess('articles')" index="/articles">文章管理</el-menu-item>
          <el-menu-item v-if="canAccess('crawl')" index="/crawl">文章收录</el-menu-item>
          <el-menu-item v-if="canAccess('sites')" index="/sites">源站点管理</el-menu-item>
        </el-submenu>
        <el-submenu v-if="canAccess('website-matrix')" index="/website-matrix-group">
          <template slot="title"><i class="el-icon-monitor"></i><span class="matrix-nav-label">官网矩阵<sup v-if="websiteMatrixUnread" title="未读官网表单">{{ websiteMatrixUnread > 99 ? '99+' : websiteMatrixUnread }}</sup></span></template>
          <el-menu-item index="/website-matrix/overview">官网总览</el-menu-item>
          <el-menu-item index="/website-matrix/sites"><span class="matrix-nav-label">官网明细<sup v-if="websiteMatrixUnread">{{ websiteMatrixUnread > 99 ? '99+' : websiteMatrixUnread }}</sup></span></el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['independent-site-products', 'product-blog', 'echotik-products', 'echotik-collection-tasks', 'automation-rules'])" index="/independent-site-ops">
          <template slot="title"><i class="el-icon-s-operation"></i><span>独立站运营</span></template>
          <el-menu-item v-if="canAccess('independent-site-products')" index="/independent-site-products">独立站商品采集</el-menu-item>
          <el-menu-item v-if="canAccess('product-blog')" index="/product-blog">产品分析</el-menu-item>
          <el-menu-item v-if="canAccess('echotik-products')" index="/echotik-products">EchoTik商品洞察</el-menu-item>
          <el-menu-item v-if="canAccess('echotik-collection-tasks')" index="/echotik-collection-tasks">EchoTik采集任务</el-menu-item>
          <el-menu-item v-if="canAccess('automation-rules')" index="/automation-rules">自动化规则配置</el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['meta-oauth', 'pinterest-marketing', 'facebook-marketing'])" index="/social-marketing">
          <template slot="title"><i class="el-icon-camera"></i><span>社媒平台营销</span></template>
          <el-menu-item v-if="canAccess('meta-oauth')" index="/meta-oauth">Meta授权验证</el-menu-item>
          <el-menu-item v-if="canAccess('pinterest-marketing')" index="/pinterest-marketing">Pinterest运营</el-menu-item>
          <el-menu-item v-if="canAccess('facebook-marketing')" index="/facebook-marketing">Facebook运营</el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['email-center', 'facebook-ad-leads', 'facebook-group-monitor', 'shop-app-hot-products', 'crm-leads', 'customer-quotes', 'partner-development', 'logistics-rates', 'crm-lead-sourcing'])" index="/customer-development">
          <template slot="title"><i class="el-icon-user"></i><span>客户拓展</span></template>
          <el-menu-item v-if="canAccess('email-center')" index="/email-center">邮件中心</el-menu-item>
          <el-menu-item v-if="groupAccess(['facebook-ad-leads', 'facebook-group-monitor', 'shop-app-hot-products', 'crm-leads', 'partner-development'])" index="/customer-development-tasks">任务总览</el-menu-item>
          <el-menu-item v-if="canAccess('facebook-ad-leads')" index="/facebook-ad-leads">Facebook广告拓客</el-menu-item>
          <el-menu-item v-if="canAccess('facebook-group-monitor')" index="/facebook-group-monitor">Facebook群组监控</el-menu-item>
          <el-menu-item v-if="canAccess('shop-app-hot-products')" index="/shop-app-hot-products">Shop平台拓展</el-menu-item>
          <el-menu-item v-if="canAccess('crm-leads')" index="/crm-leads">拓客联系人</el-menu-item>
          <el-menu-item v-if="canAccess('customer-quotes')" index="/customer-quotes">客户报价</el-menu-item>
          <el-menu-item v-if="canAccess('partner-development')" index="/partner-development"><span class="partner-support-nav">合作伙伴开发<sup v-if="supportUnread" title="未读客服会话">{{ supportUnread > 99 ? '99+' : supportUnread }}</sup></span></el-menu-item>
          <el-menu-item v-if="canAccess('logistics-rates')" index="/logistics-rates">物流费用</el-menu-item>
          <el-menu-item v-if="canAccess('crm-lead-sourcing')" index="/crm-lead-sourcing">客户商品寻源</el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['geo-optimization', 'shopline-config', 'shopline-blog', 'independent-site-competitors', 'shopline-product', 'shopline-product-listing', 'shopline-theme-mapping', 'shopline-profit-report'])" index="/independent-store-management">
          <template slot="title"><i class="el-icon-shopping-bag-2"></i><span>独立站管理</span></template>
          <el-menu-item v-if="canAccess('shopline-config')" index="/shopline-config">店铺授权</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-blog')" index="/shopline-blog">独立站博客管理</el-menu-item>
          <el-menu-item v-if="groupAccess(['independent-site-competitors', 'geo-optimization'])" index="/independent-site-content">独立站内容运营</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-product')" index="/shopline-product">独立站商品管理</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-product-listing')" index="/shopline-product-listing">Shopline商品上架</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-theme-mapping')" index="/shopline-theme-mapping">Shopline主题映射</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-profit-report')" index="/shopline-profit-report">Shopline利润分析</el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['independent-site-competitors', 'partner-development', 'facebook-ad-leads', 'facebook-group-monitor', 'shop-app-hot-products', 'crm-leads', 'crm-lead-sourcing'])" index="/agent-management">
          <template slot="title"><i class="el-icon-cpu"></i><span>Agent管理</span></template>
          <el-menu-item index="/agent-tokens">Agent令牌</el-menu-item>
          <el-menu-item index="/agent-tasks">任务中心</el-menu-item>
          <el-menu-item index="/agent-setup">配置教程</el-menu-item>
        </el-submenu>
        <el-submenu v-if="groupAccess(['employee-management', 'operation-logs', 'publish-templates', 'exchange-rates', 'payment-integrations', 'shopline-account-bindings', 'shopline-merchants', 'ai-config', 'ai-task-prompts', 'oss-config', 'database'])" index="/system-config">
          <template slot="title"><i class="el-icon-setting"></i><span>系统配置</span></template>
          <el-menu-item v-if="canAccess('employee-management')" index="/employees">员工管理</el-menu-item>
          <el-menu-item v-if="canAccess('operation-logs')" index="/operation-logs">日志中心</el-menu-item>
          <el-menu-item v-if="canAccess('publish-templates')" index="/publish-templates">发布模板</el-menu-item>
          <el-menu-item v-if="canAccess('exchange-rates')" index="/exchange-rates">汇率维护</el-menu-item>
          <el-menu-item v-if="canAccess('payment-integrations')" index="/payment-integrations">支付对接配置</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-account-bindings')" index="/shopline-account-bindings">店铺账户绑定</el-menu-item>
          <el-menu-item v-if="canAccess('shopline-merchants')" index="/shopline-merchants">商户信息</el-menu-item>
          <el-menu-item v-if="canAccess('ai-config')" index="/ai-config">AI配置</el-menu-item>
          <el-menu-item v-if="canAccess('ai-task-prompts')" index="/ai-task-prompts">AI场景配置</el-menu-item>
          <el-menu-item v-if="canAccess('oss-config')" index="/oss-config">阿里云OSS配置</el-menu-item>
          <el-menu-item v-if="canAccess('database')" index="/database">数据库配置</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container class="content-shell">
      <el-header class="topbar">
        <div class="topbar-search-wrap">
          <el-button v-if="$route.path === '/facebook-group-monitor'" class="group-nav-toggle" icon="el-icon-menu" circle :aria-label="groupNavOpen ? '关闭导航' : '打开导航'" :aria-expanded="groupNavOpen" @click="groupNavOpen = !groupNavOpen" />
          <el-autocomplete
            v-model="globalSearch"
            class="topbar-search"
            prefix-icon="el-icon-search"
            :fetch-suggestions="querySearch"
            placeholder="搜索页面或功能"
            clearable
            @select="openSearchResult"
          >
            <template slot-scope="{ item }">
              <div class="search-result"><span>{{ item.value }}</span><small>{{ item.groupName }}</small></div>
            </template>
          </el-autocomplete>
        </div>
        <div class="top-actions">
          <el-popover popper-class="page-help-popover" placement="bottom-end" width="380" trigger="hover">
            <div class="page-help-content">
              <strong>{{ helpTitle }}</strong>
              <ol><li v-for="item in helpSteps" :key="item">{{ item }}</li></ol>
              <template v-if="helpTips.length">
                <b>注意事项</b>
                <ul><li v-for="item in helpTips" :key="item">{{ item }}</li></ul>
              </template>
            </div>
            <el-button slot="reference" class="help-button" circle icon="el-icon-question" aria-label="页面使用说明" />
          </el-popover>
          <el-dropdown @command="handleCommand">
            <span class="user-menu"><b>{{ userInitial }}</b><span>{{ userName }}</span><i class="el-icon-arrow-down"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main :class="['main', `route-${routeSlug}`]">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { canAccessPage, PAGE_OPTIONS } from '../permissions'
import auroraMark from '../assets/qingtianzhu-aurora-mark.png'
import { getSupportAgentSummary, getWebsiteMatrixOverview } from '../api'

const manuals = {
  '/customer-development-tasks': {
    title: '客户拓展任务总览使用说明',
    steps: ['查看 Facebook广告拓客、Facebook群组监控、Shop平台拓展、拓客联系人和合作伙伴开发的真实采集任务。', '顶部只汇总正在采集、等待执行、需要处理和今日有效新增。', '点击模块卡片筛选任务，也可按来源、时间、状态和关键词检索。', '后台持续采集页集中查看长期计划、最近产出、失败原因和下次检查时间。', '遇到受阻、失败或部分完成时，进入原模块或查看任务说明处理。'],
    tips: ['任务仍在原业务模块创建；本页负责统一监控，管理员可管理后台持续采集计划。', '正在采集必须存在有效心跳或业务进展；长时间没有活动的任务会标记为需要处理。', '底层调度状态继续由系统记录，不再单独提供重复的任务监控页面。']
  },
  '/crawl': {
    title: '文章收录使用说明',
    steps: ['单篇 URL 收录用于立即采集某一篇文章详情页。', '对家博客模块监控用于配置博客列表页 URL，例如 popular articles、category、blog index 等模块页。', '保存监控源后，系统会按配置间隔自动轮询；默认每 4 小时检查一次，发现新文章 URL 后会提交采集任务并进入文章管理。', '立即检查会马上抓取列表页并提取文章链接，适合配置后测试选择器是否正确。', '文章链接选择器决定从列表页哪些 a 标签里提取文章链接，复杂站点可按页面结构调整。'],
    tips: ['列表页只负责发现文章 URL，真正的标题、正文、作者、封面仍由文章详情页采集流程完成。', '系统按原文 URL 去重，已收录文章不会重复入库。', '动态渲染、登录可见或禁止抓取的页面可能无法完整采集。']
  },
  '/articles': {
    title: '文章管理使用说明',
    steps: ['按标题关键词或文章状态筛选收录文章。', '点击详情进入文章详情页。', '文章状态会随着采集、AI分析、AI改写、发布动作自动变化。', '列表用于统一管理所有来源文章和处理进度。'],
    tips: ['采集失败的文章可检查原文 URL、站点反爬和网络访问。', '进入详情页后才能执行 AI 分析和 AI 改写。']
  },
  '/publish-templates': {
    title: '发布模板使用说明',
    steps: ['新增或编辑页面排版模板。HTML结构决定标题、摘要、封面图和正文嵌入位置，CSS决定颜色、字体大小、间距、图片圆角、表格和移动端展示。', '模板变量会在文章详情页发布前自动替换，其中 {{content}} 是 AI 改写并人工编辑后的正文。', '保存并启用后，文章详情页的发布预览会出现该模板。', '发布时系统保存模板标识和最终完整 HTML，方便后续接入自有博客发布接口。'],
    tips: ['HTML结构必须包含 {{content}}，否则正文不会进入最终页面。', '不同业务可建多个模板，例如教程型、评测型、新闻型、产品知识库型。']
  },
  '/exchange-rates': {
    title: '汇率维护使用说明',
    steps: ['维护系统统一结算使用的币种汇率，汇率含义为 1 单位原币种等于多少 USD。', '首次启动会写入默认汇率，后续可按财务口径手动调整并保存。', 'Shopline利润分析、广告成本和手续费接入后都会按启用汇率统一折算成 USD。'],
    tips: ['USD 必须保持为 1。', '如果订单出现未维护币种，利润报表会提示缺失汇率。']
  },
  '/payment-integrations': {
    title: '支付对接配置使用说明',
    steps: ['先在 Airwallex 凭证页维护 Client ID、API Key、环境和接口地址，同一组凭证只保存一次。', '在 Airwallex 支付账号中填写 Account ID，并通过下拉选择已维护凭证。', '可逐个账号点击测试认证，确认后端可以换取访问令牌并读取财务流水。', 'Shopline Payments 手续费读取复用 Shopline 店铺授权，后续在利润报表里按订单支付流水匹配费用。'],
    tips: ['API Key 留空保存时会沿用当前已保存密钥，页面不会回显完整密钥。', '新增 Airwallex 账号后，需要到店铺账户绑定页面把该账号配对到对应店铺。']
  },
  '/shopline-account-bindings': {
    title: '店铺账户绑定使用说明',
    steps: ['Meta 广告账户配对：选择 Meta 授权后加载广告账户，再勾选对应店铺。', 'Google Ads 账户配对：通过商户和 Google 授权邮箱查询已授权客户账户，按 Customer ID 配对店铺。', '支付账户配对：以 Airwallex 或 PayPal 账号为一行，勾选多个店铺用于归集支付手续费。'],
    tips: ['账户授权密钥只在后端使用，不会下发到浏览器。', '取消店铺勾选只解除当前账户类型，其他已配对关系会保留。']
  },
  '/sites': {
    title: '源站点管理使用说明',
    steps: ['维护对家或目标博客站点信息。', '域名和图标用于识别来源站点。', '采集规则 JSON 用于后续按不同站点定制正文选择器、标题选择器、排除区域等规则。', '配置后，批量收录和精细化采集会优先使用源站点规则。'],
    tips: ['当前 MVP 主要按通用文章选择器采集，复杂站点需要补充规则。']
  },
  '/website-matrix/overview': {
    title: '官网矩阵使用说明',
    steps: ['总览汇总官网品牌、未读表单、品牌博客和构建异常。', '点击待办站点或最新表单，可直接进入对应品牌的操作区。', '未读数量按当前员工独立计算，不会因其他人已读而消失。'],
    tips: ['官网博客数只计算各品牌的成稿，不包含资料库原文。', '询盘提交后仅在本系统内保存、分配和处理。']
  },
  '/website-matrix/sites': {
    title: '官网明细使用说明',
    steps: ['从左侧站点甬道选择品牌，未读数、博客数和站点状态会同时显示。', '右侧可查看官网预览、处理表单、查看品牌博客、修改 SEO 页面及追踪构建版本。', '站点配置只需填写域名和 WhatsApp，表单接收凭证由系统自动管理。'],
    tips: ['表单的未读与新线索是两组状态：打开表单只会标记已读，不会自动改成已联系。', '自动品牌名与 Logo 仍需在公开使用前完成商标检索。']
  },
  '/independent-site-products': {
    title: '独立站商品采集使用说明',
    steps: ['先录入独立站名称和首页地址，例如 https://www.karmaandluck.com。', '点击发现分类后，系统会优先读取 sitemap.xml 中的 collections 分类地址；没有 sitemap 时再按页面链接兜底。', '选择分类后点击采集商品，系统会从分类页提取商品链接，并进入商品详情页读取 JSON-LD、SEO、价格和图片。', '商品数据会落库，可按站点、分类、关键词和状态查询，不需要每次都重新访问原站。', '点击转产品分析可把采集到的商品标题、图片、SEO和结构化数据带入产品分析模块，作为后续关键词、博客角度和文章生成的上下文。'],
    tips: ['当前模块只采集公开页面，不会修改对方网站。', '首次建议每个分类小批量采集，确认字段质量后再扩大数量。', '动态渲染或反爬较强的网站可能需要后续接入浏览器渲染采集。']
  },
  '/shop-app-hot-products': {
    title: 'Shop平台拓展使用说明',
    steps: ['导入 Shop.app 店铺来源 Excel，系统按 Shop 店铺链接去重并保留工作表与原始行号。', '按品牌、域名、类目、评价数、评分和商品采集状态筛选店铺。', '勾选值得继续处理的店铺加入商品采集队列，后续在独立站商品采集页执行分类发现和商品明细采集。'],
    tips: ['页面每行是一个店铺来源，不是一件商品。', '重复导入相同文件只会更新已有店铺，不会重复增加。']
  },
  '/product-blog': {
    title: '产品分析使用说明',
    steps: ['创建产品内容项目，填写目标市场、目标用户和生成文章数量。', '上传产品图片到 OSS 后，点击产品图 AI 分析，系统会识别产品定位、卖点、场景和风险。', '输入竞品文章 URL，系统会抓取正文并分析竞品关键词、内容角度和未覆盖机会点。', '生成关键词池后，系统会批量扩展 SEO/GEO 长尾词、问题词、商业意图词和对比词。', '生成博客角度规划后，选择适合的角度批量生成英文博客。', '生成文章可一键保存到文章管理，后续复用富文本编辑、发布预览和发布模板。'],
    tips: ['AI 对产品图识别可能不准，建议先填写产品名称并人工修正分析结果。', '第一版先插入产品图和图片占位，AI 生成配图后续再接入。']
  },
  '/independent-site-content': {
    title: '独立站内容运营使用说明',
    steps: ['先选择店铺。内容工作台集中查看计划、写作进度与待办，提供人工创建计划及 Codex 推荐计划入口。', '在博客规范维护写作计划与写作要求：限定商品、方向、市场、语言、篇数和排除范围；正在执行的任务保留创建时的范围。', '博客资料库只有三个入口：补充写作资料、选题参考、系统参考资料。业务按需要添加内部资料，AI 建议和研究线索集中展示，自动来源、商品与博客索引默认折叠。商品名称和公开页面宣称需要判断，可选实测与照片不会统一阻断写作。', '竞品参考也在博客规范内。配置网址或让 Codex 找竞品，研究任务页查看执行过程；有用的研究机会可加入博客资料库。', '可以直接按计划让 Codex 自主选题写作，也可以先修改、选择主题建议再写；写作进度在内容工作台及已生成博客查看。', '已生成博客用于查看正文、来源及原任务，完成审核后保存平台草稿、发布或排期。持续执行与发布日历放在内容工作台，自动发布需要明确授权并通过独立审稿。', '效果跟踪使用真实 GSC/GA4 数据。没有数据时显示未接入，生成数量不能代替自然流效果。'],
    tips: ['主题建议和竞品研究都是可选参考；普通写作可从本店商品开始。品牌规则和已确认事实由业务按需要补充。', '发布结果不确定时先核对并关联远端文章，系统阻止重复创建。任务恢复沿用原范围、历史与稿件。', '首次进入或刷新不会默认选择店铺。带店铺或计划参数的链接仍可打开对应上下文。']
  },
  '/geo-optimization': {
    title: 'GEO增长使用说明',
    steps: ['创建GEO项目，填写品牌、目标市场、目标用户、产品/服务范围和网站地址。', '点击同步系统数据，系统会从已采集商品、Shopline商品缓存、文章和Facebook广告拓客数据中抽取真实问题与关键词。', '点击分析机会，系统会把问题池和关键词池整理成FAQ、购买指南、对比页、博客等内容机会。', '选择机会生成内容草稿，草稿会优先调用AI；AI不可用时会基于真实问题和关键词生成可编辑结构稿。', '可见性检测用于记录ChatGPT、Perplexity、Gemini等AI搜索是否提到或推荐了我们的品牌/页面。'],
    tips: ['Google Search Console、GA4、Reddit等外部数据源需要先配置授权；未配置时系统不会伪造外部数据。', '第一版不会自动发布Reddit内容，建议先生成草稿并人工审核。']
  },
  '/echotik-products': {
    title: 'EchoTik商品洞察使用说明',
    steps: ['选择榜单周期、地区、商品分类和关键词查看 TikTok 热卖商品。', '商品分类使用一级类目横向筛选，带箭头的类目可展开二级、三级菜单继续细分。', '点击榜单行进入独立详情页，查看商品、店铺、销量、GMV、带货视频、直播和佣金信息。', '该页面只展示真实热销榜单数据，不承载采集任务监控。'],
    tips: ['采集任务、失败任务、详情补齐和 worker 状态已经移动到 EchoTik采集任务 页面。', '完整 GMV、销量、达人和佣金字段依赖 Echotik 登录态和会员可见范围。']
  },
  '/echotik-collection-tasks': {
    title: 'EchoTik采集任务使用说明',
    steps: ['查看当前正式采集 worker、详情补齐 worker 和历史诊断 worker。', '确认正式采集目录、榜单文件数、去重商品数、详情补齐数量和 taxonomy 分类树。', '当类目可信度为未验证时，详情补齐任务会暂停，避免继续生成分类不可信的数据。', '刷新状态会重新读取本机 runtime 和 logs，不影响热销榜页面浏览。'],
    tips: ['smoke、test、fix 等诊断任务不会参与热销榜状态判断。', '正式重新采集应优先走 taxonomy -> list -> product-pool -> detail-backfill 链路。']
  },
  '/automation-rules': {
    title: '自动化规则配置使用说明',
    steps: ['链路1用于配置 Shopline 商品到产品分析、关键词池、博客角度、批量生成文章和 Shopline 博客发布的自动化规则。', '商品范围、每日上限、并发数量和重试次数用于控制自动化执行边界，避免一次性触发过多 AI 或发布任务。', '真实发布相关开关默认关闭，启用前需要确认 Shopline 博客集合配置正确。'],
    tips: ['当前页面负责保存流程规则，相关执行状态和异常可在日志中心查看。', '自动真实发布前建议先以草稿或只生成素材包的模式跑通。']
  },
  '/operation-logs': {
    title: '日志中心使用说明',
    steps: ['集中查看系统里的采集任务、AI任务、Shopline推送、社媒发布、自动化链路、Meta授权和三方推送记录。', '可以按模块、日志类型、状态和关键词检索。', '点击查看业务会跳回对应业务页面，方便继续处理失败或异常记录。'],
    tips: ['日志中心聚合现有业务表的最近记录，不改变原始业务数据。', '采集任务进度和执行记录统一放在日志中心，业务页只展示业务数据与业务操作。']
  },
  '/ai-config': {
    title: 'AI配置使用说明',
    steps: ['维护文本模型和图片模型，例如 OpenAI兼容、Codex、Gemini、Kimi、DeepSeek 或图片生成模型。', '填写接口地址、模型名、API Key、User-Agent、代理和请求超时。', '点击测试确认后端可以调用模型。', '保存后，这些模型会出现在 AI场景配置 页面，供每个任务单独绑定。'],
    tips: ['这里只配置模型授权和连接，不配置任务绑定、AI身份、痛点方向和输出规则。', '每个业务场景的模型绑定和提示词行为统一在 AI场景配置 页面维护。']
  },
  '/ai-task-prompts': {
    title: 'AI场景配置使用说明',
    steps: ['每一行对应一个具体 AI 调用场景，例如文章分析、文章改写、观点重合、产品图分析、关键词扩展、角度规划。', '点击编辑可配置该场景使用的模型、AI身份、业务目标、目标受众、痛点方向、关键词规则、禁区、输出格式、质量校验和兜底策略。', '保存后，后端会优先使用该场景绑定的模型，并在调用 AI 接口前自动拼接这些配置。', '鼠标移入每个字段旁边的问号，可以查看字段作用和为什么需要配置。'],
    tips: ['模型账号、API Key、代理仍在 AI配置 页面管理；具体任务用哪个模型在这里绑定。', '如果某个任务临时不想追加场景配置，可以把启用关闭。']
  },
  '/oss-config': {
    title: '阿里云OSS配置使用说明',
    steps: ['填写 Endpoint、Bucket、AccessKey 和存储目录。', '点击测试连接确认后端可以访问 Bucket。', '点击测试并保存后，文章详情页插入图片和视频会通过本地附件上传到 OSS。', '上传成功后系统把 OSS 公网 URL 插入改写正文，发布预览和发布记录都会使用该 URL。'],
    tips: ['Bucket 需要允许最终发布页面访问这些资源。', 'AccessKey Secret 留空保存时会沿用当前已保存 Secret。']
  },
  '/employees': {
    title: '员工管理使用说明',
    steps: ['新增员工账号，设置用户名、昵称、初始密码和启用状态。', '在页面权限里勾选该员工可以访问的页面，保存后员工登录只会看到这些菜单。', '编辑员工时密码可留空，表示不修改当前密码。', '停用员工账号后，该员工无法继续登录系统。'],
    tips: ['管理员账号默认拥有全部页面权限，不受员工权限限制。', '页面权限控制用于后台菜单和路由访问控制，敏感业务操作后续可继续扩展接口级权限。']
  },
  '/shopline-config': {
    title: '独立站店铺授权使用说明',
    steps: ['在 Shopline 或 Shopify 标签页分别管理对应平台的店铺，检索条件和分页各自保留。', '在当前平台填写店铺域名或 handle；可用换行、逗号、空格或分号分隔多个店铺。', '刷新本平台店铺只处理当前平台；授权接口路径不变，界面只展示脱敏摘要。', 'Shopline 与 Shopify 使用各自的 Token 校验规则；Shopify 会实际读取店铺信息验证授权，不要求令牌包含 JWT 到期时间。'],
    tips: ['授权接口地址、User-Agent、X-API-Secret 和 X-Auth-Token 不在页面配置，仍由后端统一维护。', '博客页面支持 Shopline 和 Shopify；商品、上架、主题和利润页面仍使用 Shopline 业务适配器。']
  },
  '/shopline-merchants': {
    title: '商户信息使用说明',
    steps: ['页面从 Fulfillagent 商户目录接口读取当前商户和店铺归属。', '可按商户名称、商户编号、店铺名称、店铺标识或域名搜索。', '展开商户行查看该商户在各个平台下的店铺明细。', '点击刷新数据会重新读取上游接口，不会修改商户或店铺。'],
    tips: ['外部接口密钥只由后端使用，浏览器不会收到密钥、访问令牌或上游原始响应。', '上游接口暂时不可用时，页面会保留明确的错误提示，不会将空数据视为真实商户目录。']
  },
  '/shopline-blog': {
    title: '独立站博客管理使用说明',
    steps: ['先选择 Shopify 博客或 Shopline 博客页签，再选择该平台已授权的店铺。', '可以创建或更新博客集合，用于承载后续博客文章。', '选择某个博客集合后查询文章列表，使用上一页和下一页浏览；两个平台分别保留选择和分页位置。', '文章正文使用 HTML 内容，新建文章默认保存为草稿；Shopify 文章需要填写作者。'],
    tips: ['接口复用店铺授权页面保存的密钥，Shopify 使用 GraphQL API。', 'Shopify 页面会检查博客读取和写入权限，缺少写入权限时禁用保存操作。', '评论管理当前支持 Shopline。']
  },
  '/shopline-product': {
    title: '独立站商品管理使用说明',
    steps: ['先选择 Shopify 商品或 Shopline 商品页签，再选择该平台已授权的店铺。', 'Shopify 可直接查询商品、按状态或标题／Handle／ID 搜索，并使用上一页和下一页浏览。', 'Shopify 商品详情包含价格、规格／SKU、库存和图片，规格或图片较多时可以继续加载。', 'Shopline 保留商品、分类、图片、文件的缓存同步、产品分析和1688链接管理。'],
    tips: ['两个平台分别保留店铺选择、筛选条件和分页位置。', 'Shopify 商品读取需要 read_products 权限，密钥仍由后端安全使用。', 'Shopline 的原始接口查询和写入开关继续沿用现有配置。']
  },
  '/shopline-product-listing': {
    title: 'Shopline商品上架使用说明',
    steps: ['输入独立站采集商品 ID，选择目标 Shopline 店铺和主题模板，系统会自动生成一个可编辑上架草稿。', '草稿会把标题、副标题、描述、SEO、图片/视频、SKU、变体、标签和主题模板路径整理成 Shopline 商品创建 payload。', '编辑草稿时可以人工修正标题、Handle、分类、SEO、正文、SKU JSON、媒体 JSON 和元字段 JSON。', '点击校验会检查必填字段、模板路径、图片、SKU、重复 SKU 和 SEO 长度。', '点击推送 Shopline 草稿会调用商品创建接口；页面顶部会显示当前是真实写入模式还是 dry-run 校验模式。'],
    tips: ['主题模板 template_path 只负责绑定商品详情页模板，不会自动填充主题里的自定义组件。', 'Item Details、Care Guidelines、Stones & Symbols 等主题组件通过 Metafields JSON 承载；推送草稿时会调用 Shopline metafields_set 接口写入商品元字段，默认仍受 dry-run 保护。']
  },
  '/shopline-theme-mapping': {
    title: 'Shopline主题映射使用说明',
    steps: ['主题映射用于定义某个店铺、某个主题的商品字段如何写入主题组件。', '映射规则由来源字段、组件匹配JSON、动作类型和写入规则JSON组成，商品上架时会按排序依次执行。', '如果更换主题或新增主题，先复制默认映射，再按 Shopline 当前主题的组件 type、settings 标题和字段结构调整规则。', '执行日志用于排查为什么某个字段没有写入页面，例如未匹配到主题组件、来源字段为空或模板渲染失败。'],
    tips: ['这套配置只影响商品上架生成的专属主题模板，不会改变采集源数据。', '修改规则后建议先用单个草稿商品推送测试，确认日志匹配成功后再批量上架。']
  },
  '/meta-oauth': {
    title: 'Meta授权验证使用说明',
    steps: ['先把页面展示的“授权回调网址”填写到 Meta 应用后台的授权回调配置里。', '点击生成授权链接后，用拥有 Facebook Page 或广告账户访问权限的账号登录并授权。', '授权回调成功后，系统会自动兑换长期 User Token，并读取授权用户可访问的 Facebook Page、广告账户或审核演示所需数据。', '授权记录显示 SUCCESS 后，可到 Facebook运营、Meta广告成本分析或审核演示页面继续验证。'],
    tips: ['仅按当前业务所需申请和展示 Facebook / Marketing API 相关权限。', '回调地址必须是 HTTPS 公网地址，线上建议使用 https://one.fulfillagent.com/api/meta/oauth/callback。']
  },
  '/pinterest-marketing': {
    title: 'Pinterest运营使用说明',
    steps: ['维护自有 Pinterest Business 或 Creator 账号。', '发 Pin 时选择账号、Pin 类型、Board、标题、描述、落地页 URL、Alt 文本和媒体 URL。', 'AI Pin 素材包围绕产品、关键词、Board 和落地页生成标题与描述。', '发布任务区后续接入 Pinterest API 后用于查看创建 Pin、视频媒体处理和发布结果。'],
    tips: ['Pinterest 内容强依赖 Board 和搜索关键词，标题、描述、Alt 文本都应该围绕搜索意图组织。', '当前页面已完成前端框架，真实 OAuth 和发布接口需要后续后端接入。']
  },
  '/facebook-marketing': {
    title: 'Facebook运营使用说明',
    steps: ['维护自有 Facebook Page 授权，Facebook 官方 API 不支持自动发布到个人主页。', '按帖子类型填写文字、链接、图片或视频内容。', 'AI Page 素材包围绕产品、目标用户、语气和落地页生成 Facebook 文案。', '发布任务区后续接入 Graph API 后用于查看 feed、photo、video 发布状态。'],
    tips: ['Facebook 发布需要 Page Access Token 和 pages_manage_posts 权限。', '当前页面已完成前端框架，真实 OAuth 和发布接口需要后续后端接入。']
  },
  '/facebook-ad-leads': {
    title: 'Facebook广告拓客使用说明',
    steps: ['输入产品、目标国家和广告主数量，创建一个后台采集任务。', '按输入的产品词和补充关键词逐个查询，整理广告主并按主页ID或官网去重。', '业务页仅展示广告主结果和业务操作，执行进度和异常请到日志中心查看。', '结果可按联系质量和国家筛选，查看官网、邮箱、电话、WhatsApp及联系表单的公开证据。'],
    tips: ['采集任务由线上服务在后台自动处理，业务页不暴露内部执行方式和任务状态。', '“B2B可联系”只代表公开联系渠道及用途符合当前规则，首次触达前仍应人工核对。']
  },
  '/customer-quotes': { title: '客户报价使用说明', summary: '在同一列表处理联系人与广告主的商品、寻源及正式报价。', steps: ['按来源、阶段或关键词筛选；来源记录保持独立。', '查看商品证据和1688候选，确认重量、目的地和物流后制作报价。', '报价工作台统一审核、发送与查看历史；生成和审核不会发送邮件。'] },
  '/crm-leads': {
    title: '拓客联系人使用说明',
    steps: ['顶部数字用于快速进入今日待跟进、可直接触达、A/B级高优先级和待分配队列。', '列表按跟进到期时间、线索等级和综合评分排序，可搜索商家、域名、联系人或公开联系方式。', '点击线索查看评分拆解、推荐触达方式、公开意向信号、联系人证据、社媒主页和代表商品。', '记录跟进可维护当前阶段、负责人、下次跟进时间和业务备注。'],
    tips: ['联系人和渠道来自公开来源与证据链，首次触达前仍应核对有效性。', '页面依赖 001_core_crm_schema.sql 中的 CRM 核心表；缺表时页面会明确提示。']
  },
  '/crm-lead-sourcing': {
    title: '客户商品寻源使用说明',
    steps: ['系统会扫描拓客联系人下已有商品图的客户商品，并自动提交 1688 图片找品。', '每个客户商品保留前 8 个 1688 候选品，候选品和客户线索、商家、原商品图保持绑定。', '点击客户行查看商品图片、寻源状态和候选商品，可手动重新寻源或勾选报价候选。', '后续报价邮件可以基于已勾选候选品生成对应客户的产品报价单。'],
    tips: ['自动任务只处理有商品图且未成功寻源的商品，避免重复调用。', '失败商品可通过页面手动强制重跑。']
  },
  '/partner-development': {
    title: '合作伙伴开发使用说明',
    steps: ['系统从 Shopify、WooCommerce、BigCommerce、Wix、Webflow 等公开伙伴名录和企业官网持续发现合作机构。', '系统按明确伙伴类型、企业官网、可验证服务能力和合作边界进行规则分类，不用评分拦截采集或发送。', '伙伴类型与服务平台分开管理；同一机构可以关联多个平台，并可按任一条件筛选。', '系统持续补全公开联系人和企业邮箱；A-D 级联系人都可发送，并分级分析打开、回复和退信。', '收到真人回复后会停止同一公司其他联系人的自动序列，并进入会议、试点、推荐、首单和毛利闭环。'],
    tips: ['当前版本不做无边界爬取，也不会自动群发邮件。', '合作伙伴与现有客户线索分库存放，避免把渠道伙伴误当成终端商家。']
  },
  '/logistics-rates': {
    title: '物流费用使用说明',
    steps: ['导入云途物流报价 Excel，系统会识别每个工作表对应的运输渠道、产品代码和生效时间。', '运费试算按目的国家和商品重量命中重量区间；不指定渠道时会同时计算全部可用渠道并推荐最低价。', '普通渠道按挂号费加公斤费乘计费重量计算，日本等渠道按首重加续重计算。', '客户报价邮件会读取已选1688商品重量，自动选择最低可用渠道并写入运输渠道、时效、国际物流费和单件总价。'],
    tips: ['重量区间下限不包含、上限包含，例如0.1KG会命中0<W≤0.1。', '缺少重量、国家未覆盖或超过渠道重量上限时不会写入0元，而是保留空白供业务人员检查。']
  },
  '/email-center': {
    title: '邮件中心使用说明',
    steps: ['先在邮箱配置中填写 Titan 邮箱与应用密码，并测试 SMTP 和 IMAP 均连接成功。', '新建邮件会进入发送队列，后台自动发送并独立记录发送、打开、回复和退信状态。', '系统每分钟同步收件箱，通过邮件标准会话头匹配客户回复；单个邮箱失败不会阻塞其他邮箱。', '在会话详情可查看完整往来记录并直接回复。'],
    tips: ['“已检测打开”来自追踪图片，受图片拦截和邮箱隐私代理影响，不等于100%真人阅读。', 'SMTP发送成功表示邮箱服务器已接收；后续退信会通过IMAP同步为“已退信”。']
  },
  '/database': {
    title: '数据库配置使用说明',
    steps: ['填写 MySQL 主机、端口、数据库名、账号和密码。', '点击测试连接确认后端可访问数据库。', '点击测试并保存后，运行中的后端会切换到新数据源。', '切换后，文章、提示词、站点、AI分析、改写记录、发布记录都会读写这个数据库。'],
    tips: ['阿里云 RDS 需要确认白名单、安全组、账号权限和数据库名。', '密码留空保存时会沿用当前已保存密码。']
  },
  '/agent-tokens': {
    title: 'Agent令牌使用说明',
    steps: ['每台运行 Codex 的机器签发一个独立令牌。', '令牌能力由签发人的页面权限决定，可用于对应页面的白话采集或持续任务。', '令牌只显示一次，复制后在目标机器通过 blogai auth login 登录。', '机器停用或令牌疑似泄露时立即撤销，执行中任务会释放回队列。'],
    tips: ['不要把令牌提交到 Git、粘贴到任务简报或保存到浏览器前端。', '服务端只保存令牌 SHA-256 摘要，无法找回原令牌。']
  },
  '/agent-tasks': {
    title: 'Agent任务中心使用说明',
    steps: ['一次性采集请进入对应业务页面，点击“用 Codex 采集”，直接描述要找什么，不需要填写字段名或 JSON。', 'Codex 会读取该业务页面的数据合同，将已采集内容映射到预设字段并返回写入回执。', '需要目标数量、进度、断点续跑、定时巡检或入群流程时，再到任务中心发布持续任务。', '持续任务的结果和执行事件仍在任务详情及日志中心查看。'],
    tips: ['白话采集只保存结构化业务字段和来源证据，不保存原始网页 JSON。', '采集写入不会自动发邮件、消息、入群或启动其他任务。']
  },
  '/agent-setup': {
    title: 'Agent配置教程说明',
    steps: ['选择 Windows CMD、Windows PowerShell 或 macOS/Linux，复制对应安装命令。', '安装程序从当前服务器下载业务 CLI 并准备 Agent 工作目录，不需要系统源码。', '使用当前系统对应的命令和一次性 Agent 令牌登录。', '运行 doctor 自检后用 Codex 打开工作目录。'],
    tips: ['无人值守时可用 codex exec，但仍应保持最小沙盒权限。', '不要让 Agent 直接连接生产数据库或管理员接口。']
  }
}

export default {
  name: 'AppLayout',
  data() {
    return {
      globalSearch: '',
      groupNavOpen: false,
      supportUnread: 0,
      supportSocket: null,
      supportReconnectTimer: null,
      supportReconnectAttempt: 0,
      supportHeartbeatTimer: null,
      supportPollTimer: null,
      websiteMatrixUnread: 0,
      websiteMatrixPollTimer: null,
      auroraMark
    }
  },
  computed: {
    userName() {
      if (this.$store.state.user?.nickname) return this.$store.state.user.nickname
      return this.$route.query.demo === '1' ? '演示预览' : '未登录'
    },
    isAdmin() {
      return this.$store.state.user?.role === 'admin'
    },
    activeMenu() {
      if (this.$route.path.startsWith('/articles/')) {
        return '/articles'
      }
      if (this.$route.path.startsWith('/website-matrix/sites/')) return '/website-matrix/sites'
      if (this.$route.path.startsWith('/customer-quotes/')) return '/customer-quotes'
      return this.$route.path
    },
    routeSlug() {
      return String(this.$route.path || 'home').replace(/^\//, '').replace(/[^a-z0-9-]+/gi, '-') || 'home'
    },
    routeSection() {
      const path = this.$route.path || ''
      if (['/customer-development-tasks', '/facebook-ad-leads', '/facebook-group-monitor', '/shop-app-hot-products', '/crm-leads', '/customer-quotes', '/crm-lead-sourcing', '/partner-development', '/logistics-rates', '/email-center', '/sales-quotes'].some(item => path.startsWith(item))) return '客户拓展'
      if (['/shopline-account-bindings', '/shopline-merchants'].some(item => path.startsWith(item))) return '系统配置'
      if ((path.startsWith('/independent-site-competitors') || path.startsWith('/independent-site-content'))) return '独立站管理'
      if (path.startsWith('/shopline')) return 'SHOPLINE 平台'
      if (['/meta-oauth', '/pinterest-marketing', '/facebook-marketing'].some(item => path.startsWith(item))) return '社媒平台营销'
      if (path.startsWith('/website-matrix')) return '官网矩阵'
      if (['/independent-site-products', '/product-blog', '/geo-optimization', '/echotik-products', '/echotik-collection-tasks', '/automation-rules'].some(item => path.startsWith(item))) return '独立站运营'
      if (['/articles', '/crawl', '/sites'].some(item => path.startsWith(item))) return '内容管理'
      if (['/agent-tokens', '/agent-tasks', '/agent-setup'].some(item => path.startsWith(item))) return 'Agent管理'
      if (['/employees', '/operation-logs', '/publish-templates', '/exchange-rates', '/payment-integrations', '/ai-config', '/ai-task-prompts', '/oss-config', '/database'].some(item => path.startsWith(item))) return '系统配置'
      return '运营总览'
    },
    routeIcon() {
      return ({
        '客户拓展': 'el-icon-user',
        'SHOPLINE 平台': 'el-icon-shopping-bag-2',
        '独立站管理': 'el-icon-shopping-bag-2',
        '社媒平台营销': 'el-icon-camera',
        '独立站运营': 'el-icon-s-operation',
        '官网矩阵': 'el-icon-monitor',
        '内容管理': 'el-icon-document',
        'Agent管理': 'el-icon-cpu',
        '系统配置': 'el-icon-setting',
        '运营总览': 'el-icon-data-analysis'
      })[this.routeSection]
    },
    userInitial() {
      return String(this.userName || 'Q').trim().slice(0, 1).toUpperCase()
    },
    helpContent() {
      if (this.$route.path.startsWith('/articles/')) {
        return {
          title: '文章详情使用说明',
          steps: ['在原文预览中查看收录文章的页面效果；采集HTML用于检查入库后的可发布结构，源页面用于对比原站真实效果。', '纯文本用于检查 AI 输入内容是否完整。', '点击 AI分析后，系统会生成分析状态、分析时间、摘要、关键词、分类、可读性、好的地方、不足和建议优化内容。', 'AI分析和AI改写的身份、方向、关键词规则、输出格式统一由系统配置里的 AI场景配置 管理。', '点击 AI改写后，系统会结合原文、AI分析结果和文章改写场景配置，生成纯英文标题、摘要、HTML正文、SEO标题、SEO描述和标签。', '改写版本可以编辑标题、摘要、SEO信息和正文HTML，也可以通过本地附件上传图片和视频到 OSS 后插入正文。', '富文本工具条可调整标题、段落、字体大小、颜色、加粗、斜体、下划线、对齐和列表。', '发布模板用于把改写正文嵌入完整页面结构，模板可在发布模板页面配置颜色、字体、图片和布局风格。', '切换发布模板检查最终预览样式、SEO标题和SEO描述后再发布；发布记录会保存模板和最终 HTML。'],
          tips: ['源页面可能因为 X-Frame-Options 或站点安全策略无法嵌入，此时以采集 HTML 预览为准。', '如果采集HTML仍然乱，重新提交同一个 URL 会刷新采集结果。']
        }
      }
      if (this.$route.path.startsWith('/website-matrix/sites/')) return manuals['/website-matrix/sites']
      return manuals[this.$route.path] || {
        title: '页面使用说明',
        steps: ['按页面表单提示完成操作。', '如遇错误，优先查看页面顶部错误提示。'],
        tips: []
      }
    },
    helpTitle() {
      return this.helpContent.title
    },
    helpSteps() {
      return this.helpContent.steps || []
    },
    helpTips() {
      return this.helpContent.tips || []
    },
    searchablePages() {
      const pages = [
        { groupName: '客户拓展', name: '任务总览', path: '/customer-development-tasks' },
        ...PAGE_OPTIONS
      ]
      return pages.filter((item, index, source) => {
        if (source.findIndex(candidate => candidate.path === item.path) !== index) return false
        return !item.code || this.canAccess(item.code)
      })
    }
  },
  mounted() {
    const designPreview = process.env.NODE_ENV === 'development' && this.$route.query.demo === '1'
    if (!designPreview && this.canAccess('customer-support')) {
      this.refreshSupportUnread()
      this.connectSupportNotifications()
      this.supportPollTimer = window.setInterval(this.refreshSupportUnread, 10000)
    }
    if (!designPreview && this.canAccess('website-matrix')) {
      this.refreshWebsiteMatrixUnread()
      this.websiteMatrixPollTimer = window.setInterval(() => {
        if (document.visibilityState === 'visible') this.refreshWebsiteMatrixUnread()
      }, 30000)
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.supportReconnectTimer)
    window.clearInterval(this.supportHeartbeatTimer)
    window.clearInterval(this.supportPollTimer)
    window.clearInterval(this.websiteMatrixPollTimer)
    if (this.supportSocket) { this.supportSocket.onclose = null; this.supportSocket.close() }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$store.commit('logout')
        this.$router.push('/login')
      }
    },
    canAccess(code) {
      return canAccessPage(this.$store.state.user, code)
    },
    groupAccess(codes) {
      return codes.some(code => this.canAccess(code))
    },
    querySearch(query, done) {
      const keyword = String(query || '').trim().toLowerCase()
      const rows = this.searchablePages
        .filter(item => !keyword || `${item.name} ${item.groupName}`.toLowerCase().includes(keyword))
        .slice(0, 10)
        .map(item => ({ ...item, value: item.name }))
      done(rows)
    },
    openSearchResult(item) {
      this.globalSearch = ''
      if (!item?.path) return
      const [path, search = ''] = item.path.split('?')
      const query = {}
      new URLSearchParams(search).forEach((value, key) => { query[key] = value })
      this.$router.push({ path, query }).catch(() => {})
    },
    async refreshSupportUnread() {
      try {
        const summary = await getSupportAgentSummary(true)
        this.supportUnread = Number(summary?.unreadConversations || 0)
      } catch (_) { /* Existing navigation remains usable when support is unavailable. */ }
    },
    async refreshWebsiteMatrixUnread() {
      try {
        const summary = await getWebsiteMatrixOverview()
        this.websiteMatrixUnread = Number(summary?.unreadLeads || 0)
      } catch (_) { /* Navigation remains usable when the website module is unavailable. */ }
    },
    connectSupportNotifications() {
      const token = localStorage.getItem('BLOG_AI_TOKEN')
      if (!token || typeof WebSocket === 'undefined') return
      window.clearTimeout(this.supportReconnectTimer)
      window.clearInterval(this.supportHeartbeatTimer)
      if (this.supportSocket) { this.supportSocket.onclose = null; this.supportSocket.close() }
      const url = process.env.VUE_APP_SUPPORT_WS_URL || `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/api/support/ws`
      const socket = new WebSocket(url)
      this.supportSocket = socket
      socket.onopen = () => {
        this.supportReconnectAttempt = 0
        socket.send(JSON.stringify({ type: 'auth', role: 'AGENT', token }))
      }
      socket.onmessage = event => {
        let payload
        try { payload = JSON.parse(event.data) } catch (_) { return }
        if (payload.type === 'auth.ok') {
          window.clearInterval(this.supportHeartbeatTimer)
          this.supportHeartbeatTimer = window.setInterval(() => {
            if (socket.readyState === WebSocket.OPEN) socket.send(JSON.stringify({ type: 'ping' }))
          }, 25000)
        }
        if (payload.type === 'auth.error') socket.close()
        if (payload.type === 'message.created' && payload.message?.senderType === 'CUSTOMER') {
          this.refreshSupportUnread()
          const alreadyViewing = this.$route.path === '/partner-development' && this.$route.query.tab === 'support'
          if (!alreadyViewing) {
            this.$notify({
              title: '新的在线客服消息',
              message: String(payload.message.bodyText || '合作伙伴发来一条新消息').slice(0, 80),
              type: 'info',
              duration: 7000,
              onClick: () => this.$router.push({ path: '/partner-development', query: { tab: 'support' } }).catch(() => {})
            })
          }
        }
        if (['conversation.updated', 'read.updated'].includes(payload.type)) this.refreshSupportUnread()
      }
      socket.onerror = () => socket.close()
      socket.onclose = () => {
        window.clearInterval(this.supportHeartbeatTimer)
        const delay = Math.min(30000, 1000 * (2 ** this.supportReconnectAttempt++))
        this.supportReconnectTimer = window.setTimeout(this.connectSupportNotifications, delay)
      }
    }
  }
}
</script>

<style scoped>
.app-shell {
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  background: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar .el-menu {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  border-right: 0;
}

.brand {
  flex: 0 0 60px;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  color: var(--qt-text-strong);
  font-size: 18px;
  font-weight: 700;
}

.content-shell {
  height: 100vh;
  min-width: 0;
  overflow: hidden;
}

.topbar {
  flex: 0 0 60px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.help-button {
  border: 0;
  color: #4b5563;
}

.main {
  height: calc(100vh - 60px);
  min-height: 0;
  padding: 22px;
  overflow: auto;
}

.user-menu {
  cursor: pointer;
}

.manual h3 {
  margin: 0 0 12px;
}

.manual li {
  margin: 8px 0;
  line-height: 1.7;
}

.manual-tips {
  margin-top: 18px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.manual-tips h4 {
  margin: 0 0 8px;
}

.partner-support-nav { display: inline-flex; align-items: center; gap: 7px; }
.partner-support-nav sup { min-width: 19px; height: 19px; padding: 0 5px; display: inline-flex; align-items: center; justify-content: center; border-radius: 999px; color: #fff; background: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,.14); font-size: 9px; font-weight: 800; line-height: 1; }
.matrix-nav-label { display: inline-flex; align-items: center; gap: 7px; }
.matrix-nav-label sup { min-width: 19px; height: 19px; padding: 0 5px; display: inline-flex; align-items: center; justify-content: center; border-radius: 999px; color: #fff; background: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,.14); font-size: 9px; font-weight: 800; line-height: 1; }
</style>

<style>
.app-shell {
  height: 100vh;
  overflow: hidden;
  background: var(--qt-bg);
}

.app-shell .sidebar {
  position: relative;
  width: 240px !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-right: 1px solid var(--qt-border);
  box-shadow: none;
}

.app-shell .sidebar .brand {
  flex: 0 0 64px;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 20px;
  color: var(--qt-text-strong);
  border-bottom: 1px solid var(--qt-border);
}

.brand-mark {
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-mark img {
  display: block;
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.brand-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.brand-copy strong {
  color: var(--qt-text-strong);
  font-size: 17px;
  font-weight: 650;
  letter-spacing: -.02em;
}

.brand-copy small {
  color: var(--qt-text-faint);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: .16em;
}

.nav-caption {
  padding: 0 24px 10px;
  color: #69739e;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: .16em;
}

.app-shell .sidebar > .el-menu {
  flex: 1;
  min-height: 0;
  padding: 12px 8px 18px;
  overflow-x: hidden;
  overflow-y: auto;
  border-right: 0;
}

.app-shell .sidebar .el-menu-item,
.app-shell .sidebar .el-submenu__title {
  height: 42px;
  margin: 2px 0;
  padding: 0 14px !important;
  color: var(--qt-text) !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 42px;
  border-radius: 7px;
  transition: color .18s ease, background-color .18s ease;
}

.app-shell .sidebar .el-menu-item:hover,
.app-shell .sidebar .el-submenu__title:hover {
  color: var(--qt-primary) !important;
  background: var(--qt-primary-hover-soft) !important;
}

.app-shell .sidebar .el-menu-item.is-active {
  color: var(--qt-primary) !important;
  font-weight: 600;
  background: var(--qt-primary-soft) !important;
  box-shadow: inset 2px 0 0 var(--qt-primary);
}

.app-shell .sidebar .el-menu-item i,
.app-shell .sidebar .el-submenu__title i {
  width: 22px;
  margin-right: 8px;
  color: var(--qt-text-muted);
  font-size: 16px;
  text-align: center;
}

.app-shell .sidebar .el-menu-item.is-active i,
.app-shell .sidebar .el-menu-item:hover i,
.app-shell .sidebar .el-submenu__title:hover i {
  color: var(--qt-primary);
}

.app-shell .sidebar .el-submenu .el-menu {
  background: transparent !important;
}

.app-shell .sidebar .el-submenu .el-menu-item {
  min-width: 0;
  height: 40px;
  padding-left: 46px !important;
  color: var(--qt-text-muted) !important;
  font-size: 13px;
  line-height: 40px;
}

.app-shell .sidebar .el-submenu .el-menu-item.is-active {
  color: var(--qt-primary) !important;
}

.sidebar-footer {
  flex: 0 0 auto;
  margin: 10px 14px 14px;
  padding: 13px 14px;
  background: #181d48;
  border: 1px solid rgba(134, 145, 219, .16);
  border-radius: 12px;
}

.sidebar-footer span,
.sidebar-footer small {
  display: block;
}

.sidebar-footer span {
  color: #d6dcf3;
  font-size: 11px;
  font-weight: 650;
}

.sidebar-footer span i {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  background: #42cf98;
  border-radius: 50%;
}

.sidebar-footer small {
  margin-top: 6px;
  color: #7882ab;
  font-size: 9px;
  letter-spacing: .04em;
}

.app-shell .content-shell {
  height: 100vh;
  min-width: 0;
  overflow: hidden;
}

.app-shell .topbar {
  z-index: 10;
  flex: 0 0 62px;
  height: 62px !important;
  padding: 0 28px;
  background: #fff;
  border-bottom: 1px solid var(--qt-border);
  box-shadow: none;
}

.topbar-search-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
}

.topbar-search {
  width: min(520px, 44vw);
}

.topbar-search .el-input__inner {
  height: 36px;
  color: var(--qt-text);
  background: var(--qt-surface-soft);
  border-color: var(--qt-border);
  border-radius: 8px;
}

.app-shell .top-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-shell .help-button {
  color: var(--qt-text-muted);
  background: #fff;
  border-color: var(--qt-border);
}

.app-shell .main {
  height: calc(100vh - 62px);
  min-height: 0;
  padding: 18px 20px 36px;
  overflow: auto;
  background: var(--qt-bg);
}

.app-shell .user-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 9px 5px 5px;
  color: var(--qt-text);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
}

.app-shell .user-menu b {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  background: #7aa8f5;
  border-radius: 50%;
}

.app-shell .user-menu span {
  max-width: 120px;
  overflow: hidden;
  font-size: 13px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-shell .manual-tips {
  background: var(--qt-primary-soft);
  border-color: #dfe2ff;
  border-radius: 10px;
}

.page-help-popover {
  max-height: min(620px, calc(100vh - 90px));
  overflow: auto;
  padding: 16px 18px;
  color: var(--qt-text);
  border-color: var(--qt-border);
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(75, 98, 135, .13);
}

.page-help-content > strong {
  display: block;
  margin-bottom: 10px;
  color: var(--qt-text-strong);
  font-size: 15px;
  font-weight: 600;
}

.page-help-content ol,
.page-help-content ul {
  margin: 0;
  padding-left: 20px;
}

.page-help-content li {
  margin: 7px 0;
  color: var(--qt-text);
  font-size: 13px;
  line-height: 1.6;
}

.page-help-content b {
  display: block;
  margin-top: 13px;
  padding-top: 12px;
  color: var(--qt-text-strong);
  font-size: 13px;
  border-top: 1px solid var(--qt-border);
}

@media (max-width: 1500px) {
  .app-shell .sidebar { width: 210px !important; }
  .app-shell .sidebar .brand { padding: 0 16px; }
  .app-shell .main { padding: 20px 22px 36px; }
}

@media (max-width: 1180px) {
  .app-shell .sidebar { width: 196px !important; }
  .app-shell .main { padding: 18px; }
}

.group-nav-toggle, .group-nav-backdrop { display: none; }
@media (max-width: 700px) {
  .app-shell.group-mobile-shell .sidebar { position: fixed; left: 0; top: 0; z-index: 2100; width: 240px !important; transform: translateX(-100%); visibility: hidden; }
  .app-shell.group-mobile-shell.group-nav-open .sidebar { transform: translateX(0); visibility: visible; }
  .group-mobile-shell .group-nav-backdrop { display: block; position: fixed; inset: 0; z-index: 2099; border: 0; background: rgba(0,0,0,.35); }
  .group-mobile-shell .group-nav-toggle { display: inline-block; }
  .app-shell.group-mobile-shell .topbar { padding: 0 12px; }
  .app-shell.group-mobile-shell .topbar-search { width: min(62vw, 360px); }
  .app-shell.group-mobile-shell .top-actions { gap: 8px; }
  .app-shell.group-mobile-shell .main { padding: 12px 8px; }
}
</style>
